import {createSlice } from '@reduxjs/toolkit'

const ModalSlice = createSlice({
    name: "ModalSlice",
    initialState: {
        OpenModal: {
            OpenLogin: true,
            OpenModalAddStaff: false,
            OpenModalAddCity: false,
            OpenMainMenu: false,
            OpenRevenue: false,
            OpenStaffManagment: false,
            OpenDeletedStaff: false,
            OpenChoicePeriod: false,
            OpenModalAddUser: false,
            OpenUserManagment: false,
            OpenOptionMenu: false,
            OpenRevenueButtonsMenu: false,
            OpenOtherMenu: false,
            OpenChoiceComponentAR: false,
            SelectedSystem: false,
            OpenEnteringDataAR: false,
            OpenAddArticleED: false,
            OpenAddArticleAPI: false,
            OpenArticleManagment: false,
            OpenSummaryReports: false,
            OpenARMainMenu: false,
            openRevenueModule: false,
        },
        
    },
    reducers: {
       setOpenModalAddStaff(state, actions){
        state.OpenModal.OpenModalAddStaff = actions.payload
       },
       setOpenModalAddCity(state, actions){
        state.OpenModal.OpenModalAddCity = actions.payload
       },
       setOpenModalAddUser(state, actions){
        state.OpenModal.OpenModalAddUser = actions.payload
       },
       setOpenMainMenu(state, actions){
        state.OpenModal.OpenMainMenu = actions.payload
        if(!actions.payload)
            state.OpenOptionMenu = false

        if(actions.payload)
        {
            state.OpenModal.OpenModalAddStaff = false
            state.OpenModal.OpenModalAddCity = false
            state.OpenModal.OpenRevenue = false
            state.OpenModal.OpenStaffManagment = false
            state.OpenModal.OpenDeletedStaff = false
            state.OpenModal.OpenChoicePeriod = false
            state.OpenModal.OpenModalAddUser = false
            state.OpenModal.OpenUserManagment = false
            state.OpenModal.OpenOptionMenu = false
            state.OpenModal.OpenRevenueButtonsMenu = false
            state.OpenModal.OpenOtherMenu = false
            state.OpenModal.OpenChoiceSystem = false
            state.OpenModal.OpenARMainMenu = false
        }
       },
       setOpenLogin(state, actions){
        state.OpenModal.OpenLogin = actions.payload
       },
       setOpenRevenue(state, actions){
        state.OpenModal.OpenRevenue = actions.payload
        if(!actions.payload)
            state.OpenModal.OpenRevenueButtonsMenu = false
       },
       setOpenStaffManagment(state, actions){
        state.OpenModal.OpenStaffManagment = actions.payload
       },
       setOpenDeletedStaff(state, actions){
        state.OpenModal.OpenDeletedStaff = actions.payload
       },
       setOpenChoicePeriod(state, actions){
        state.OpenModal.OpenChoicePeriod = actions.payload
       },
       setOpenUserManagment(state, actions){
        state.OpenModal.OpenUserManagment = actions.payload
       },
       CloseAll(state){
        state.OpenModal.OpenModalAddStaff = false
        state.OpenModal.OpenModalAddCity = false
        state.OpenModal.OpenMainMenu = false
        state.OpenModal.OpenRevenue = false
        state.OpenModal.OpenStaffManagment = false
        state.OpenModal.OpenDeletedStaff = false
        state.OpenModal.OpenChoicePeriod = false
        state.OpenModal.OpenModalAddUser = false
        state.OpenModal.OpenUserManagment = false
        state.OpenModal.OpenLogin = true
        state.OpenModal.OpenOptionMenu = false
        state.OpenModal.OpenRevenueButtonsMenu = false
        state.OpenModal.OpenOtherMenu = false
        state.OpenModal.OpenChoiceSystem = false
        state.OpenModal.OpenChoiceComponentAR = false
        state.OpenModal.SelectedSystem = false
        state.OpenModal.OpenEnteringDataAR = false
        state.OpenModal.OpenAddArticleED = false
        state.OpenModal.OpenAddArticleAPI = false
        state.OpenModal.OpenArticleManagment = false
        state.OpenModal.OpenSummaryReport = false
        state.OpenModal.OpenARMainMenu = false
        state.OpenModal.openRevenueModule = false
       },
       TransitionSystem(state){
        state.OpenModal.OpenModalAddStaff = false
        state.OpenModal.OpenModalAddCity = false
        state.OpenModal.OpenMainMenu = false
        state.OpenModal.OpenRevenue = false
        state.OpenModal.OpenStaffManagment = false
        state.OpenModal.OpenDeletedStaff = false
        state.OpenModal.OpenChoicePeriod = false
        state.OpenModal.OpenModalAddUser = false
        state.OpenModal.OpenUserManagment = false
        state.OpenModal.OpenOptionMenu = false
        state.OpenModal.OpenRevenueButtonsMenu = false
        state.OpenModal.OpenOtherMenu = false
        state.OpenModal.OpenChoiceSystem = true
        state.OpenModal.OpenChoiceComponentAR = false
        state.OpenModal.SelectedSystem = false
        state.OpenModal.OpenEnteringDataAR = false
        state.OpenModal.OpenAddArticleED = false
        state.OpenModal.OpenAddArticleAPI = false
        state.OpenModal.OpenArticleManagment = false
        state.OpenModal.OpenSummaryReport = false
        state.OpenModal.OpenARMainMenu = false
        state.OpenModal.openRevenueModule = false
       },
       setOpenOptionMenu(state, actions){
        state.OpenModal.OpenOptionMenu = actions.payload
       },
       setOpenRevenueButtonsMenu(state, actions){
        state.OpenModal.OpenRevenueButtonsMenu = actions.payload
       },
       setOpenOtherMenu(state, actions){
        state.OpenModal.OpenOtherMenu = actions.payload
       },
       setOpenChoiceSystem(state, actions){
        state.OpenModal.OpenChoiceSystem = actions.payload
       },
       setOpenChoiceComponentAR(state, actions){
        state.OpenModal.OpenChoiceComponentAR = actions.payload
       },
       setSelectedSystem(state, actions){
        state.OpenModal.SelectedSystem = actions.payload
       },
       setOpenEnteringDataAR(state, actions){
        state.OpenModal.OpenEnteringDataAR = actions.payload
       },
       setOpenAddArticleED(state, actions){
        state.OpenModal.OpenAddArticleED = actions.payload
       },
       setOpenAddArticleAPI(state, actions){
        state.OpenModal.OpenAddArticleAPI = actions.payload
       },
       setOpenArticleManagment(state, actions){
        state.OpenModal.OpenArticleManagment = actions.payload
       },
       setOpenSummaryReport(state, actions){
       state.OpenModal.OpenSummaryReport = actions.payload
       },
       setOpenARMainMenu(state, actions){
        state.OpenModal.OpenARMainMenu = actions.payload
       },
       setOpenRevenueModule(state, actions) {
        state.OpenModal.openRevenueModule = actions.payload;
       }
    }
})

export default ModalSlice.reducer
export const { 
    setOpenAddArticleAPI,
    setOpenAddArticleED, 
    TransitionSystem, 
    setOpenEnteringDataAR, 
    setSelectedSystem, 
    setOpenChoiceComponentAR, 
    setOpenChoiceSystem, 
    setOpenOptionMenu, 
    setOpenRevenueButtonsMenu, 
    setOpenOtherMenu, 
    setOpenUserManagment, 
    setOpenModalAddStaff, 
    setOpenModalAddUser, 
    setOpenModalAddCity, 
    setOpenMainMenu, 
    setOpenLogin, 
    setOpenRevenue, 
    setOpenStaffManagment, 
    setOpenDeletedStaff, 
    setOpenChoicePeriod, 
    CloseAll,
    setOpenArticleManagment,
    setOpenSummaryReport,
    setOpenARMainMenu,
    setOpenRevenueModule
 } = ModalSlice.actions